//libs
import { styled } from '@nykaa/ui-components';
import { SORT_CONTAINER_WIDTH } from 'shared/layouts/Listing/Desktop/components/Layout/constants';

export const Wrapper = styled.div`
  display: flex;
  justify-content: end;
  width: ${SORT_CONTAINER_WIDTH}px;
`;
